export type Thumbnail = {
  title: string;
  imgSrc: string;
  to: string;
  type?: 'essential' | 'annals';
  contentId: string;
};
export interface Link {
  id?: string;
  // slug: string;
  label: string;
  url: string;
  // hidden: boolean;
  // children?: { id: string; type: string }[];
  // essentialsArray?: string[];
  // contentType?: ContentTypes;
}

export type Links = Array<Link>;

export type AnchorLink = {
  id: string;
  label?: string;
  position: Ref<number>;
  selected?: boolean;
};

export enum Sections {
  Home = '',
  InTheNews = 'a-la-une',
  Challenges = 'challenges',
  Trophies = 'trophee',
  Revisions = 'revisions',
  Championship = 'championnat',
  Orientation = 'orientation',
  Nomad = 'nomad',
  Famille = 'famille',
  ParentForYou = 'pour-vous',
  Gaming = 'gaming',
  ChildForYou = 'pour-toi',
  MyFriends = 'mes-amis',
}

export enum BroadcastMessages {
  UpdateProfile = 'UpdateProfile',
  LogOut = 'LogOut',
  InstallationComplete = 'InstallationComplete',
}

export const BroadcastId = 'nomad';

export enum QuizStage {
  Stage0 = '0',
  Stage1 = '1',
  Stage2 = '2',
  Stage3 = '3',
  Stage4 = '4',
  Stage5 = '5',
}

export interface DialogProp {
  dialog: Component;
  data: any;
}

export enum DialogLevel {
  System = 0,
  Settings = 1,
  Info = 2,
  Reward = 3,
  All = 100,
}

export interface AssessmentListItem extends AssessmentSchema {
  title: string;
  chapters: { title: string; id: string }[];
  uuid: string;
  imgSrc: string;
  daysLeft: number;
  formatedDate: string;
  clockTime: string;
  timeLeft: number;
  ended: boolean;
  count: number;
  total: number;
}

export enum CategoryPageTypes___ {
  Category = 'category',
  Quiz = 'quiz',
  Exercise = 'exercise',
  Post = 'post',
  Home = 'home',
  AssessmentForm = 'assessment-form',
  AssessmentRun = 'assessment-run',
  AssessmentRunQuiz = 'assessment-run-quiz',
  AssessmentRunPost = 'assessment-run-post',
}

export enum CategoryPageContextTypes {
  Classic = 'classic',
  Home = 'home',
  AssessmentForm = 'assessment-form',
  AssessmentRun = 'assessment-run',
  AssessmentRunQuiz = 'assessment-run-quiz',
  AssessmentRunPost = 'assessment-run-post',
}

export enum CategoryPageContentTypes {
  Category = 'category',
  Quiz = 'quiz',
  Exercise = 'exercise',
  Post = 'post',
}

export enum AssessmentFormSteps {
  SELECT_CHAPTERS = 'select-chapters',
  SELECT_DATE = 'select-date',
  COMPLETED = 'completed',
}

export enum AssessmentFormSelectorTypes {
  Disciplines = 'disciplines',
  Chapters = 'chapters',
  Forbidden = 'forbidden',
}
